import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";

import {
  Cart,
  Home,
  Orders,
  Profile,
  AboutUs,
  Register,
  Category,
  Products,
  ContactUs,
  OrderDetails,
} from "screen";
import { colors } from "asset/constant";
import { useRecoilValue } from "recoil";
import { authAtom } from "store";
import { webPagesTitle } from "router/webPagesTitle";

const Stack = createNativeStackNavigator<Routes>();

export default function HomeStack() {
  const auth = useRecoilValue(authAtom);

  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: colors.bg.screen },
      }}
    >
      {!auth?.user?.code && (
        <Stack.Screen name={"register"} component={Register} />
      )}

      <Stack.Screen
        name={"home"}
        component={Home}
        options={{ title: webPagesTitle.home }}
      />
      <Stack.Screen
        name={"category"}
        component={Category}
        options={{ title: webPagesTitle.category }}
      />
      <Stack.Screen
        name={"products"}
        component={Products}
        options={{ title: webPagesTitle.products }}
      />
      <Stack.Screen
        name={"profile"}
        component={Profile}
        options={{ title: webPagesTitle.profile }}
      />

      <Stack.Screen
        name={"cart"}
        component={Cart}
        options={{ title: webPagesTitle.cart }}
      />

      <Stack.Screen
        name={"orders"}
        component={Orders}
        options={{ title: webPagesTitle.orders }}
      />
      <Stack.Screen
        name={"order_details"}
        component={OrderDetails}
        options={{ title: webPagesTitle.order_details }}
      />

      <Stack.Screen
        name={"contact_us"}
        component={ContactUs}
        options={{ title: webPagesTitle.contact_us }}
      />
      <Stack.Screen
        name={"about_us"}
        component={AboutUs}
        options={{ title: webPagesTitle.about_us }}
      />
    </Stack.Navigator>
  );
}
